// Utility to understand and display time calculations

export const analyzeRouteTimeCalculation = (route) => {
  if (!route?.stops?.length) return null;
  
  console.log('⏱️ Analyzing route time calculation:', {
    crewName: route.crewName,
    totalServiceTime: route.totalServiceTime,
    stops: route.stops.length
  });
  
  let calculationBreakdown = {
    estimatedHoursTotal: 0,
    arrivalDepartureTotal: 0,
    loadingUnloadingTime: 0,
    stops: []
  };
  
  route.stops.forEach((stop, index) => {
    const estimatedMinutes = (stop.estimatedHours || 0) * 60;
    const arrivalDepartureMinutes = stop.estimatedDepartureTime && stop.estimatedArrivalTime
      ? (stop.estimatedDepartureTime - stop.estimatedArrivalTime) / 60  // Convert seconds to minutes
      : 0;
    
    calculationBreakdown.estimatedHoursTotal += estimatedMinutes;
    calculationBreakdown.arrivalDepartureTotal += arrivalDepartureMinutes;
    
    const stopAnalysis = {
      order: index + 1,
      estimatedHours: stop.estimatedHours,
      estimatedMinutes,
      arrivalTime: stop.estimatedArrivalTime,
      departureTime: stop.estimatedDepartureTime,
      arrivalDepartureMinutes,
      difference: arrivalDepartureMinutes - estimatedMinutes
    };
    
    calculationBreakdown.stops.push(stopAnalysis);
    
    console.log(`  Stop ${index + 1}:`, {
      estimatedHours: stop.estimatedHours,
      estimatedMinutes,
      arrivalDepartureMinutes: arrivalDepartureMinutes.toFixed(2),
      difference: stopAnalysis.difference.toFixed(2)
    });
  });
  
  // The difference is likely loading/unloading time
  calculationBreakdown.loadingUnloadingTime = 
    calculationBreakdown.arrivalDepartureTotal - calculationBreakdown.estimatedHoursTotal;
  
  console.log('  Summary:', {
    estimatedHoursTotal: (calculationBreakdown.estimatedHoursTotal / 60).toFixed(2) + 'h',
    arrivalDepartureTotal: (calculationBreakdown.arrivalDepartureTotal / 60).toFixed(2) + 'h',
    loadingUnloadingTime: calculationBreakdown.loadingUnloadingTime.toFixed(2) + 'min',
    routeTotalServiceTime: route.totalServiceTime + 'min',
    matches: Math.abs(route.totalServiceTime - calculationBreakdown.arrivalDepartureTotal) < 1
  });
  
  return calculationBreakdown;
};

export const getServiceTimeExplanation = (route) => {
  const analysis = analyzeRouteTimeCalculation(route);
  if (!analysis) return null;
  
  const baseHours = (analysis.estimatedHoursTotal / 60).toFixed(2);
  const totalHours = (route.totalServiceTime / 60).toFixed(2);
  const extraMinutes = analysis.loadingUnloadingTime.toFixed(0);
  
  if (Math.abs(analysis.loadingUnloadingTime) > 5) {
    return {
      baseHours,
      totalHours,
      extraMinutes,
      explanation: `${baseHours}h service + ${extraMinutes}min prep/travel = ${totalHours}h total`
    };
  }
  
  return {
    baseHours,
    totalHours,
    extraMinutes: '0',
    explanation: `${totalHours}h total service time`
  };
};